import config from '../../config';
import { request } from '../../libraries/request';

const getAll = (params = {}, token) => {
  console.log('SERVICES::INITIATIVES::get', params, token);
  if (params && params.page_num && config.QUERIES_PAGE_SIZE) {
    params.page_size = config.QUERIES_PAGE_SIZE;
  }
  if (!params.order_by) {
    params.order_by = 'created_at';
    params.order_direction = 'DESC';
  }

  return request({
    url: config.BASE_API_URL + config.API.INITIATIVES,
    accessToken: token,
    data: params
  }).then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {
      response.data.query.page_size = config.QUERIES_PAGE_SIZE;
    }
    return response;
  });
};

const save = (data, token) => {
  console.log('SERVICES::INITIATIVES::save', data, token);
  return request({
    url: config.BASE_API_URL + config.API.INITIATIVES,
    accessToken: token,
    method: 'POST',
    data
  }).then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {
    }
    return response;
  });
};

const update = (data, token) => {
  console.log('SERVICES::INITIATIVES::update', data, token);
  return request({
    url: config.BASE_API_URL + config.API.INITIATIVE.replace('{id}', data.id),
    accessToken: token,
    method: 'PATCH',
    data
  }).then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {
    }
    return response;
  });
};

const get = (id, token) => {
  console.log('SERVICES::INITIATIVES::get', id, token);
  return request({
    url: config.BASE_API_URL + config.API.INITIATIVE.replace('{id}', id),
    accessToken: token
    // data: {},
  }).then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {
      console.log(response.data.data?.json_data);
      if (typeof response.data.data?.json_data === 'string') {
        response.data.data.json_data = response.data.data?.json_data.replaceAll('\n', '');
        response.data.data.json_data = JSON.parse(response.data.data.json_data);
      }
    }
    return response;
  });
};

const del = (id, token) => {
  console.log('SERVICES::INITIATIVES::remove', id, token);
  return request({
    url: config.BASE_API_URL + config.API.INITIATIVE.replace('{id}', id),
    accessToken: token,
    method: 'DELETE'
  }).then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {
    }
    return response;
  });
};

const services = {
  getAll,
  save,
  get,
  del,
  update
};

export default services;
